package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class DepartmentsResponse(
  val departments: List<Department>
) {
  @Serializable
  data class Department(
    val code: String,
    val name: String
  )
}
